import { createAsyncThunk } from "@reduxjs/toolkit";
import overallReportingApi from "app/api/overallReporting";
import moment from "moment";

// (1) dealer: stockout by branch -- start
export const getDealerStockoutByBranchData = createAsyncThunk(
    "reporting/getDealerStockoutByBranchData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutByBranchData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
);
// (1) dealer: stockout by branch -- end

// (2) dealer: stockout by category -- start
export const getDealerStockoutByCategoryData = createAsyncThunk(
    "reporting/getDealerStockoutByCategoryData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutByCategoryData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
);
// (2) dealer: stockout by category -- end

// (3) dealer: stockout by brand -- start
export const getDealerStockoutByBrandData = createAsyncThunk(
    "reporting/getDealerStockoutByBrandData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutByBrandData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
);
// (3) dealer: stockout by brand -- end

// (4) dealer: stockout by model -- start
export const getDealerStockoutByModelData = createAsyncThunk(
    "reporting/getDealerStockoutByModelData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutByModelData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
);
// (4) dealer: stockout by model -- end

// (5) dealer: stockout by product -- start
export const getDealerStockoutByProductData = createAsyncThunk(
    "reporting/getDealerStockoutByProductData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutByProductData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
)
// (5) dealer: stockout by product -- end

// (6) dealer: branch title -- start
export const getDealerBranchTitleData = createAsyncThunk(
    "reporting/getDealerBranchTitleData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerBranchTitleData({
            branch_uuid: payload.branch_uuid,
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
)
// (6) dealer: branch title -- end

// (7) stockout by dealer -- start
export const getDealerStockoutData = createAsyncThunk(
    "reporting/getDealerStockoutData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
)
// (7) stockout by dealer -- end

// (8) stockout by employee -- start
export const getDealerStockoutByEmployeeData = createAsyncThunk(
    "reporting/getDealerStockoutByEmployeeData",
    async (payload, thunkApi) => {
        return overallReportingApi.getDealerStockoutByEmployeeData({
            length: payload.length,
            start: payload.start,
            search: payload.search,
            orderBy: payload.orderBy,
            orderDirection: payload.orderDirection,
            search_by: payload.searchBy,
            branch_uuid: payload.branch_uuid,
            category_uuid: payload.category_uuid,
            brand_uuid: payload.brand_uuid,
            model_uuid: payload.model_uuid,
            product_uuid: payload.product_uuid,
            period: payload.period,
            start_date: moment(payload.start_date).format('YYYY-MM-DD'),
            end_date: moment(payload.end_date).format('YYYY-MM-DD'),
            url : payload.url,
        })
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
)
// (8) stockout by employee -- end